import { render, staticRenderFns } from "./weaponTransferProtokoll.vue?vue&type=template&id=e0c4fa3c&scoped=true"
import script from "./weaponTransferProtokoll.vue?vue&type=script&lang=js"
export * from "./weaponTransferProtokoll.vue?vue&type=script&lang=js"
import style0 from "./weaponTransferProtokoll.vue?vue&type=style&index=0&id=e0c4fa3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c4fa3c",
  null
  
)

export default component.exports